// Copyright (c) 2021 Siemens

/**
 * @module js/DesTeamMembersService
 */
export const getAssignedTeamMembers = (sharedData, listTeamMembers, membersAfterRemovalAction, filteredMembersAfterRemoval, vmo) => {
    const { data, dispatch } = vmo;
    let membersListOnMainPanel = data.membersListOnMainPanel;
    if (sharedData.existingMembers) {
        if (filteredMembersAfterRemoval.length > 0) {
            membersListOnMainPanel = membersAfterRemovalAction;
        } else {
            membersListOnMainPanel = listTeamMembers;
        }
    } else {
        if (filteredMembersAfterRemoval.length > 0) {
            membersListOnMainPanel = membersAfterRemovalAction;
        } else {
            const assignedTeamMembers = sharedData.selectedObjects;
            Array.prototype.push.apply(membersListOnMainPanel, assignedTeamMembers);
            const dataArr = membersListOnMainPanel.map(item => {
                return [item.cellHeader1, item]
            }); // creates array of array

            const maparr = new Map(dataArr); // create key value pair from array of array
            const result = [...maparr.values()];
            membersListOnMainPanel = result;
        }
    }
    data.membersListOnMainPanel = membersListOnMainPanel;
    dispatch({ path: 'data', value: { ...data } });
    return {
        membersListOnMainPanel,
        totalAssignedTeamMembers: membersListOnMainPanel.length
    }
};

export const removeTeamMembers = (commandContext, membersToRemove, vmo) => {
    const { data, dispatch } = vmo;
    let filteredObj = [];
    let filteredMembers = [];
    const name = commandContext.cellHeader1;
    filteredObj = membersToRemove.filter(object => {
        return object.cellHeader1 !== name;
    });
    filteredMembers = membersToRemove.filter(object => {
        return object.cellHeader1 === name;
    });
    data.filteredObj = filteredObj;
    data.filteredMembers = filteredMembers;
    dispatch({ path: 'data', value: { ...data } });
    return {
        filteredObj, filteredMembers
    };
};

export const resetArrays = (vmo) => {
    const { data, dispatch } = vmo;
    data.filteredObj = [];
    data.filteredMembers = [];
    dispatch({ path: 'data', value: { ...data } });
};

export const parseMemberArrays = (vmo, initialMembersFromQuery) => {
    const { data } = vmo;
    const members = data.membersListOnMainPanel;
    const membersToAdd = members.filter(
        object1 => !initialMembersFromQuery.some(
            object2 => object1.cellHeader1 === object2.cellHeader1
        ),
    );
    const membersToRemove = initialMembersFromQuery.filter(
        object1 => !members.some(
            object2 => object1.cellHeader1 === object2.cellHeader1
        ),
    );
    const emailsOfMembersToRemove = [];
    membersToRemove.forEach(value => emailsOfMembersToRemove.push(value.cellHeader2));
    return {
        membersToAdd,
        emailsOfMembersToRemove
    }
};

export const switchPanel = (commandContext, panelView) => {
    const sharedData = commandContext.value;
    sharedData.activeView = panelView;
    commandContext.update({ ...sharedData });
};

export const getTeamMembers = (vmo, membersToStore) => {
    const { data, dispatch } = vmo;
    data.members = membersToStore;
    dispatch({ path: 'data', value: { ...data } });
};

export const storeData = (dataProvider, sharedData) => {
    const sharedDataVal = sharedData.value;
    sharedDataVal.selectedObjects = dataProvider.selectedObjects;
    sharedDataVal.activeView = sharedData.panelView;
    sharedDataVal.existingMembers = false;
    sharedData.update({ ...sharedDataVal });
};

export const backActionCreateTeam = sharedData => {
    sharedData.activeView = 'createTeamMainPanel';
    return sharedData;
};

export const resetPanelCreateTeam = sharedData => {
    sharedData.activeView = 'createTeamMainPanel';
    return sharedData;
};

export const backActionEditTeam = sharedData => {
    sharedData.activeView = 'editTeamMainPanel';
    return sharedData;
};

export const resetPanelEditTeam = sharedData => {
    sharedData.activeView = 'editTeamMainPanel';
    return sharedData;
};

export const resetSkipVals = (vmo) => {
    const {
        data,
        dispatch
    } = vmo;

    data.skip = 0;
    dispatch({ path: 'data.skip', value: 0 });
};
